<template>
  <div>
    <el-dialog
      title="ยืนยันรหัสผ่าน"
      :visible.sync="show"
      :label-position="labelPosition"
      :before-close="handleClose"
      width="400px"
    >
      <el-form>
        <el-form-item label="เพื่อยืนยันการแจ้งขอลบบัญชี กรุณากรอกรหัสผ่าน ">
          <el-input v-model="password" show-password></el-input>
          <br><br/>
          <el-button class="pull-right" type="primary" size="small" @click="checkPassword(this.password)">บันทึก</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      labelPosition: "top",
      show: false,
      password: '',
      test: ''
    };
  },
  watch: {
    dialog() {
      this.show = this.dialog;
    },
    info() {
      this.test = this.info
    }
  },
  props: ["info", "dialog"],
  methods: {
     ...mapActions({
      getUser: "Manage_user/getUser",
      updateProfile: "Manage_user/updateProfile",
      changePassword: "Manage_user/changePassword",
      comparePassword: "Manage_user/comparePassword",
      deleteAccountRequest: "Manage_user/deleteAccountRequest"
    }),
    handleClose(done) {
      this.$emit("checkModal", false);
      done();
    }
  },
  async checkPassword(password) {
      let user_data = {
        admin_id: this.info.admin_id,
        password: password
      }
      let result = await this.comparePassword(user_data)
      return result
    }
};
</script>
 